import { Injectable, ErrorHandler as ErrorHandler0 } from "@angular/core";
import { ErrorHandlerService } from "../service";

@Injectable()
export class ErrorHandler implements ErrorHandler0 {
  constructor(private readonly errorHandlerService: ErrorHandlerService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(error: any): void {
    this.errorHandlerService.error(error);
  }
}
